var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"backWrap",on:{"click":_vm.gotoBack}},[_c('el-button',{staticClass:"backBtn",attrs:{"type":"primary"}},[_vm._v("返回主页"),_c('i',{staticClass:"el-icon-s-promotion el-icon--right"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }